import { CardListLoader, TableLoader } from 'ui';

import { useLayoutStore } from '~/store';

export const NavigationLayoutLoader = () => {
  const { layout } = useLayoutStore();
  return layout === 'table' ? <TableLoader /> : <CardListLoader />;
};
